import React from 'react';
import Modal from '../../../../../components/Modal';
import Select from '../../../../../components/input/Select';
import TextArea from '../../../../../components/input/TextArea';
import { MAXIMUM_NUMBER_OF_TAG_REJECT_REASON } from '../../../../../constants/service/common/utilConstants';
import './TagRejectModal.scss';

const TagRejectModal = (props) => {
  const { isOpen, data, onChange, closeModal, rejectTag, type, reason } = props;
  const { rejectTypeList } = data;

  return (
    <Modal
      title="태그 거절 사유"
      isOpen={isOpen}
      width={870}
      height={500}
      isFooter={true}
      overflow="hidden"
      onOk={() => rejectTag()}
      onClose={() => closeModal()}
    >
      <div className="tag-reject-modal">
        <div className="reject-type">
          <div className="title">거절 타입</div>

          <Select
            list={rejectTypeList}
            onChange={(value) =>
              onChange({
                name: 'type',
                value,
              })
            }
            value={type}
            size="large"
          />
        </div>

        <div className="reject-reason">
          <div className="title">
            거절 상세 사유
            <span>
              ({reason.length}/{MAXIMUM_NUMBER_OF_TAG_REJECT_REASON})
            </span>
          </div>

          <TextArea
            className="reject-reason-input"
            value={reason}
            maxLength={MAXIMUM_NUMBER_OF_TAG_REJECT_REASON}
            onChange={(value) =>
              onChange({
                name: 'reason',
                value,
              })
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default TagRejectModal;
